import React from 'react'
import styled from 'styled-components'
import { useLocation } from 'react-router'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'
import { media } from 'styles/media'

import Avatar from '../../../components/display/Avatar'
import AvatarStack from '../../../components/display/AvatarStack'
import ButtonLink from '../../../components/display/ButtonLink'
import LazyImage from '../../../components/display/LazyImage'

import { VisibilityHint } from './shared'

const hostUserAvatars = [
  {
    id: '80669',
    avatar: {
      thumb:
        'https://assets.riparide.com/user/80669/avatar/thumb-b44554fb0b95aa7d52c81fe3a7ca1a4e.jpg',
      thumbMd:
        'https://assets.riparide.com/user/80669/avatar/thumb_md-f1291e65769af875a27a92326f75db1e.jpg',
      thumbLg:
        'https://assets.riparide.com/user/80669/avatar/thumb_lg-9346d0dab64ea95ad672d76ddc767a4b.jpg',
    },
  },
  {
    id: '31100',
    avatar: {
      thumb:
        'https://assets.riparide.com/user/31100/avatar/thumb-f5972948ff99e2fe9a76fdf06e086b62.jpg',
      thumbMd:
        'https://assets.riparide.com/user/31100/avatar/thumb_md-ff64ac6507b72f7012c5b3a0039fff64.jpg',
      thumbLg:
        'https://assets.riparide.com/user/31100/avatar/thumb_lg-5e59e12afb6f7796bb45b8b880ee1250.jpg',
    },
  },
  {
    id: '5263',
    avatar: {
      thumb:
        'https://assets.riparide.com/user/5263/avatar/thumb-11a3fe6224a557fe302ab10cdb0c81bc.jpg',
      thumbMd:
        'https://assets.riparide.com/user/5263/avatar/thumb_md-28850d187fdb915a03a5903cec41a275.jpg',
      thumbLg:
        'https://assets.riparide.com/user/5263/avatar/thumb_lg-d6c795a8feeecba492fb5061e7345831.jpg',
    },
  },
  {
    id: '19434',
    avatar: {
      thumb:
        'https://assets.riparide.com/user/19434/avatar/thumb-485f6a7c5f5904a8e22bafade09e3a40.jpg',
      thumbMd:
        'https://assets.riparide.com/user/19434/avatar/thumb_md-6118dcaf04f369d5af9211fb534a5fff.jpg',
      thumbLg:
        'https://assets.riparide.com/user/19434/avatar/thumb_lg-cb135ac39d6eb63100f2812296338c60.jpg',
    },
  },
  {
    id: '37067',
    avatar: {
      thumb:
        'https://assets.riparide.com/user/37067/avatar/thumb-7309752dc499b9b2e925d85d15d635e2.png',
      thumbMd:
        'https://assets.riparide.com/user/37067/avatar/thumb_md-7cd60d8863206563ada6bce3d61d5c88.png',
      thumbLg:
        'https://assets.riparide.com/user/37067/avatar/thumb_lg-e72d0639d230acde15a426d103a747e1.png',
    },
  },
  {
    id: '14188',
    avatar: {
      thumb:
        'https://assets.riparide.com/user/14188/avatar/thumb-a7bb5396f7591fe439030f6a932e34a6.jpg',
      thumbMd:
        'https://assets.riparide.com/user/14188/avatar/thumb_md-1aba6f07bebdf8e255b98668af6f5af7.jpg',
      thumbLg:
        'https://assets.riparide.com/user/14188/avatar/thumb_lg-6c96cf67a008e5c89deb30964f5b3505.jpg',
    },
  },
]

const ContentWrapper = styled.div`
  max-width: 475px;

  h3 {
    font-size: ${({ theme }) => theme['-ds-font-size-xl']['font-size'].value};
    font-weight: ${({ theme }) =>
      theme['-ds-font-size-xl']['font-weight'].value};
    color: ${({ theme }) => theme['-ds-core-400'].value};
    margin: 0 0 10px 0;
  }

  p {
    font-size: ${({ theme }) => theme['-ds-font-size-sm']['font-size'].value};
    color: ${({ theme }) => theme['-ds-core-300'].value};
  }

  ${ButtonLink} {
    ${media.lg`
      max-width: 220px;
    `}

    margin: 30px 0 20px 0;
  }
`

const AvatarRow = styled.div`
  display: flex;

  ${Avatar} {
    &:not(:last-child) {
      margin-right: 20px;
    }
  }

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`

const AvatarStackWrapper = styled.div``

const IllustrationWrapper = styled.div`
  ${media.lg`
    margin: auto;
  `}

  ${Avatar} {
    width: 64px;
    height: 64px;
    margin: 0;
    flex-shrink: 0;

    ${media.lg`
      width: 74px;
      height: 74px;
    `}
  }

  ${AvatarStackWrapper} {
    margin-bottom: 20px;
  }
`

const Inner = styled.div`
  background-color: ${({ theme }) => theme['-ds-neutral-200'].value};
  border-radius: 6px;
  padding: 30px;
  display: flex;
  flex-direction: column-reverse;

  ${media.lg`
    flex-direction: row;
  `}
`

const AvatarGrid = () => (
  <>
    <AvatarRow>
      {hostUserAvatars.slice(0, 3).map((user) => (
        <Avatar>
          <LazyImage data-src={user.avatar.thumbLg} />
        </Avatar>
      ))}
    </AvatarRow>
    <AvatarRow>
      {hostUserAvatars.slice(3).map((user) => (
        <Avatar>
          <LazyImage data-src={user.avatar.thumbLg} />
        </Avatar>
      ))}
    </AvatarRow>
  </>
)

const EditListingCard = () => {
  const { lg: largerThanLg } = useMediaQueryContext()
  const { search } = useLocation()

  const avatarStackUrls = hostUserAvatars.map(({ avatar }) => avatar.thumbLg)

  return (
    <Inner>
      <ContentWrapper>
        <h3>Join a community of proud hosts</h3>
        <p>
          Riparide Hosts are a community of like-minded people who love to
          support their local areas and host with excellence
        </p>
        <ButtonLink href={`/set-password${search}`} rounded>
          Become a Host
        </ButtonLink>
        <VisibilityHint>This content is only visible to you</VisibilityHint>
      </ContentWrapper>
      <IllustrationWrapper>
        {largerThanLg ? (
          <AvatarGrid />
        ) : (
          <AvatarStackWrapper>
            <AvatarStack urls={avatarStackUrls} />
          </AvatarStackWrapper>
        )}
      </IllustrationWrapper>
    </Inner>
  )
}

export default EditListingCard
